/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import TextArea from 'components/TextArea';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import S from '../styles.scss';

const IfiClearingArea = ({
  hasPets,
  customerResponsibilitiesReviewed,
  broughtMaterials,
  materialsNote,
  handleHaltQuestion,
  handleMaterialsNote,
  submitNewSpecifics,
}) => <Card className={S.card}>
  <div className={S.headerContainer}>
    <h4 className={S.title}>Clearing the Installation Area</h4>
  </div>
  <div className={S.checklistContainer}>
    <p>Do you have pets?</p>
    <br />
    <Button
      label="YES"
      flat inverse ripple
      disabled={hasPets === 'yes'}
      className={S.standardButton}
      onClick={() => handleHaltQuestion('hasPets', 'yes')}
    />
    <Button
      label="NO"
      flat inverse ripple
      disabled={hasPets === 'no'}
      className={S.standardButton}
      onClick={() => handleHaltQuestion('hasPets', 'no')}
    />
    {hasPets === 'yes' && <ContainerDiv>
      <DropdownDiv condition={hasPets === 'yes'}>
        <p>Please ensure all animals and pets are secured and cleared from the installation area.</p>
      </DropdownDiv>
    </ContainerDiv>}
  </div>
  {hasPets.length > 0 && <ContainerDiv>
    <DropdownDiv condition={hasPets.length > 0}>
      <div className={S.checklistContainer}>
        <p>Has anyone reviewed customer responsibilities with you yet?</p>
        <br />
        <Button
          label="YES"
          flat inverse ripple
          disabled={customerResponsibilitiesReviewed === 'yes'}
          className={S.standardButton}
          onClick={() => handleHaltQuestion('customerResponsibilitiesReviewed', 'yes')}
        />
        <Button
          label="NO"
          flat inverse ripple
          disabled={customerResponsibilitiesReviewed === 'no'}
          className={S.standardButton}
          onClick={() => handleHaltQuestion('customerResponsibilitiesReviewed', 'no')}
        />
        {customerResponsibilitiesReviewed === 'no' && <ContainerDiv>
          <DropdownDiv condition={customerResponsibilitiesReviewed === 'no'}>
            <p>
              For a seamless and successful installation with limited delays, we ask all customers
              clear the working area and remove any devices.
            </p>
            <br />
            <ul className={S.scriptList}>
              <li>Move all furniture/personal items from around windows and out of door ways.</li>
              <li>Clear out a path to entryways being installed. Example: snow, patio furniture, plants.</li>
              <li>Security systems, doorbell-cameras, light fixtures in the way of the installation.</li>
            </ul>
            <br />
            <p>
              Last reminder is that our installers do not provide painting services and will not be
              able to paint any surfaces after the completion of installation. Please expect minor
              damage to existing paint during installation.
            </p>
          </DropdownDiv>
        </ContainerDiv>}
      </div>
    </DropdownDiv>
  </ContainerDiv>}
  {customerResponsibilitiesReviewed.length > 0 && <ContainerDiv>
    <DropdownDiv condition={customerResponsibilitiesReviewed.length > 0}>
      <div className={S.checklistContainer}>
        <p>Did you bring any materials home with you?</p>
        <br />
        <Button
          label="YES"
          flat inverse ripple
          disabled={broughtMaterials === 'yes'}
          className={S.standardButton}
          onClick={() => handleHaltQuestion('broughtMaterials', 'yes')}
        />
        <Button
          label="NO"
          flat inverse ripple
          disabled={broughtMaterials === 'no'}
          className={S.standardButton}
          onClick={() => handleHaltQuestion('broughtMaterials', 'no')}
        />
        {broughtMaterials === 'yes' && <ContainerDiv>
          <DropdownDiv condition={broughtMaterials === 'yes'}>
            <p>Great, which materials did you bring home?</p>
            <br />
            <TextArea
              label="Materials Brought Home"
              value={materialsNote}
              onChange={handleMaterialsNote}
            />
          </DropdownDiv>
        </ContainerDiv>}
      </div>
    </DropdownDiv>
  </ContainerDiv>}
  {broughtMaterials.length > 0 && <ContainerDiv>
    <DropdownDiv condition={broughtMaterials.length > 0}>
      <div className={S.checklistContainer}>
        <Fragment>
          <p>That was all the information I needed from you today.</p>
          <br />
          <p>Do you have any questions for me before we schedule the appointment?</p>
          <br />
          <p>{"Let's"} get you scheduled.</p>
          <br />
          <Button
            label="COMPLETE CHECKLIST"
            flat inverse ripple
            disabled={broughtMaterials === 'yes' && !materialsNote}
            className={S.saveButton}
            onClick={submitNewSpecifics}
          />
        </Fragment>
      </div>
    </DropdownDiv>
  </ContainerDiv>}
</Card>;

IfiClearingArea.propTypes = {
  hasPets: PropTypes.string,
  customerResponsibilitiesReviewed: PropTypes.string,
  broughtMaterials: PropTypes.string,
  materialsNote: PropTypes.string,
  handleHaltQuestion: PropTypes.func,
  handleMaterialsNote: PropTypes.func,
  submitNewSpecifics: PropTypes.func,
};

export default IfiClearingArea;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/ifiClearingArea.jsx